import Course from "./Course";

export default class NamedCourseList {
  name: string; //e.g. Bootcamp or Courses
  courses: Course[];
  constructor({name, courses}: NamedCourseList) {
    Object.assign(this, {name, courses});
  }
}